import { enableProdMode, importProvidersFrom } from "@angular/core";
import { environment } from "./environments/environment";
import { AppComponent } from "./app/app.component";
import { ServiceWorkerModule } from "@angular/service-worker";
import { provideAnimations } from "@angular/platform-browser/animations";
import { bootstrapApplication, BrowserModule } from "@angular/platform-browser";
import { HttpRequestInterceptor } from "src/app/share/services/http.interceptor";
import {
	HTTP_INTERCEPTORS,
	HttpClient,
	provideHttpClient,
	withInterceptorsFromDi,
} from "@angular/common/http";
import { MAT_DATE_LOCALE, MatNativeDateModule } from "@angular/material/core";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
// import {NgxMaskModule} from 'ngx-mask'
import { provideRouter } from "@angular/router";
import { APP_ROUTES } from "src/app/app-routing.module";
import { provideEnvironmentNgxMask } from "ngx-mask";
import { DecimalPipe } from "@angular/common";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { register } from "swiper/element/bundle";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";

export function getBaseUrl() {
	return document.getElementsByTagName("base")[0].href;
}

export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

register();

const providers = [
	importProvidersFrom(
		BrowserModule,
		MatSnackBarModule,
		MatBottomSheetModule,
		ServiceWorkerModule.register("/ngsw-worker.js", {
			enabled: environment.production,
		}),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		MatNativeDateModule,
	),
	provideEnvironmentNgxMask(),
	provideRouter(APP_ROUTES),
	{ provide: MAT_DATE_LOCALE, useValue: "en-MY" },
	{
		provide: HTTP_INTERCEPTORS,
		useClass: HttpRequestInterceptor,
		multi: true,
	},
	provideAnimations(),
	provideHttpClient(withInterceptorsFromDi()),
	{ provide: "BASE_URL", useFactory: getBaseUrl, deps: [] },
	{
		provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
		useValue: { hideRequiredMarker: true },
	},
	DecimalPipe,
];

if (environment.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, { providers }).catch((err) =>
	console.log(err),
);
